import * as React from 'react';
import { Text, View } from 'react-native';
import * as AppUtilities from "../context/AppUtilities";
import * as AppConstants from "../context/AppConstants";
import * as AppState from "../context/AppState";
import { AppContext } from "../context/AppContext";
import { CustomButton } from '../components/CustomButton';
import { CustomScrollView } from '../components/CustomScrollView';
import { useSelector, useDispatch } from 'react-redux';

export function Debug() {

  const [debug, setDebug] = React.useState(AppUtilities.getAccumulatedDebug());
  const { showTemporarySnack, showPermanentSnack, hideSnack, showSpinner, hideSpinner } = React.useContext(AppContext);
  const dispatch = useDispatch();
  const lightMode = useSelector((state) => state.lightMode);
  const extraDebug = useSelector((state) => state.extraDebug);
  const reduxState = useSelector((state) => state);

  function reloadDebug() {
    setDebug(AppUtilities.getAccumulatedDebug());
  }

  function addSomeDebug() {
    for (let i = 0; i < 10; i++) {
      AppUtilities.debug("Debug message " + (i + 1));
    }
    reloadDebug();
  }

  async function clearState() {
    await AppUtilities.removeLocalData();
    const message = "Cleared all state";
    AppUtilities.debug(message);
    showTemporarySnack(message);
  }

  function logReduxState() {
    AppUtilities.debug("Redux state:");
    AppUtilities.dir(reduxState);
    reloadDebug();
  }

  function logTransientState() {
    AppUtilities.debug("Transient state:");
    AppUtilities.dir(AppState.getAllGlobalState());
    reloadDebug();
  }

  function logSavedState() {
    AppUtilities.debug("Saved state:");
    AppUtilities.dir(AppUtilities.getAllLocalData());
    reloadDebug();
  }

  function toggleLightMode() {
    const newLightMode = !lightMode;
    dispatch(AppState.createDispatch(AppConstants.DISPATCH.LIGHT_MODE, newLightMode));
    const message = "Light Mode " + (newLightMode ? "enabled" : "disabled");
    AppUtilities.debug(message);
    showTemporarySnack(message);
  }

  function toggleExtraDebug() {
    const newExtraDebug = !extraDebug;
    dispatch(AppState.createDispatch(AppConstants.DISPATCH.EXTRA_DEBUG, newExtraDebug));
    const message = "Extra Debug " + (newExtraDebug ? "enabled" : "disabled");
    AppUtilities.debug(message);
    showTemporarySnack(message);
  }

  function toggleProducerSearch() {
    const newState = !(AppState.getGlobalState(AppConstants.SIMPLE_GLOBAL_STATE.PRODUCER_SEARCH) === true);
    AppState.setGlobalState(AppConstants.SIMPLE_GLOBAL_STATE.PRODUCER_SEARCH, newState);
    const message = "Producer search " + (newState ? "enabled" : "disabled");
    AppUtilities.debug(message);
    showTemporarySnack(message);
  }

  function toggleProductSearch() {
    const newState = !(AppState.getGlobalState(AppConstants.SIMPLE_GLOBAL_STATE.PRODUCT_SEARCH) === true);
    AppState.setGlobalState(AppConstants.SIMPLE_GLOBAL_STATE.PRODUCT_SEARCH, newState);
    const message = "Product search " + (newState ? "enabled" : "disabled");
    AppUtilities.debug(message);
    showTemporarySnack(message);
  }

  React.useEffect(() => {
    // On every re-render
    reloadDebug();
  });

  async function submitDebug() {
    try {
      hideSnack();
      showSpinner();

      const result = await AppUtilities.fetchUnauthorized(
        "Debug.submitDebug",
        "/api/quickfeedback",
        "POST",
        {
          user_input: debug
        },
      );

      if (result.body) {
        showTemporarySnack("Diagonstics submitted successfully");
      } else {
        throw new Error("Result body not found");
      }
    } catch (e) {
      AppUtilities.handleException(e, "Debug.submitDebug");
      showPermanentSnack(AppUtilities.getErrors(e));
      return e;
    } finally {
      hideSpinner();
    }
    return null;
  }

  async function resetState() {
    AppUtilities.debug("Debug.resetState");
    dispatch(
      AppState.createDispatch(
        AppConstants.DISPATCH.RESET_STATE,
      )
    );
    await AppUtilities.removeLocalData();
    showTemporarySnack("State reset");
  }

  async function testException() {
    try {
      hideSnack();
      showSpinner();
      await AppUtilities.fetchUnauthorized(
        "Debug.testException",
        "/invalid",
        "POST",
        {
          data: 42,
        }
      );
    } catch (e) {
      showPermanentSnack(AppUtilities.getErrors(e));
      AppUtilities.handleException(e, "Debug.testException");
    } finally {
      hideSpinner();
    }
  }
  
  return (
    <CustomScrollView>
      <View style={{ flexDirection: "row", flexWrap: "wrap" }}>
        {
          AppConstants.IS_DEVELOPMENT ?
              <CustomButton
                onPress={addSomeDebug}
                style={AppConstants.STYLES.margin10}
              >
                Add some debug
              </CustomButton>
            :
              null
        }
        <CustomButton
          onPress={clearState}
          style={AppConstants.STYLES.margin10}
        >
          Clear state
        </CustomButton>
        <CustomButton
          onPress={logReduxState}
          style={AppConstants.STYLES.margin10}
        >
          Log redux state
        </CustomButton>
        <CustomButton
          onPress={logTransientState}
          style={AppConstants.STYLES.margin10}
        >
          Log transient state
        </CustomButton>
        <CustomButton
          onPress={logSavedState}
          style={AppConstants.STYLES.margin10}
        >
          Log saved state
        </CustomButton>
        <CustomButton
          onPress={submitDebug}
          style={AppConstants.STYLES.margin10}
        >
          Report debug
        </CustomButton>
        <CustomButton
          onPress={toggleExtraDebug}
          style={AppConstants.STYLES.margin10}
        >
          Toggle extra debug
        </CustomButton>
        <CustomButton
          onPress={toggleLightMode}
          style={AppConstants.STYLES.margin10}
        >
          Toggle light mode
        </CustomButton>
        <CustomButton
          onPress={toggleProducerSearch}
          style={AppConstants.STYLES.margin10}
        >
          Toggle producer search
        </CustomButton>
        <CustomButton
          onPress={toggleProductSearch}
          style={AppConstants.STYLES.margin10}
        >
          Toggle product search
        </CustomButton>
        {
          AppConstants.IS_DEVELOPMENT ?
              <CustomButton
                onPress={resetState}
                style={AppConstants.STYLES.margin10}
              >
                Reset state
              </CustomButton>
            :
              null
        }
        <CustomButton
          onPress={testException}
          style={AppConstants.STYLES.margin10}
        >
          Test exception
        </CustomButton>
      </View>
      <Text selectable={true} style={AppConstants.STYLES.marginBottom10}>Log:</Text>
      <Text selectable={true} style={AppConstants.STYLES.marginBottom10}>{debug}</Text>
    </CustomScrollView>
  );
}
